// extracted by mini-css-extract-plugin
export default {"container":"item-simple_container__dYBbw","background":"item-simple_background__Er1BQ","highlight":"item-simple_highlight__gnb+4"};